import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { fetchMaintenanceById, updateMaintenance } from '../reducers/MaintenanceSlice';
import { toast } from 'react-toastify';

const UpdateMaintenance = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { maintenance, status } = useSelector(state => state.maintenances);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        title: '',
        maintenanceType: '',
        location: '',
        issueDescription: '',
        assignedTo: '',
        status: 'Pending',
        totalCost: '',
        paymentMethod: '',
        paymentDate: '',
        paidBy: '',
        workStartDate: '',
        workCompletionDate: '',
    })

    useEffect(() => {
        if (id) {
            dispatch(fetchMaintenanceById(id));
        }
    }, [id, dispatch]);

    useEffect(() => {
        if (maintenance) {
            setFormData({
                title: maintenance.title || '',
                maintenanceType: maintenance.maintenanceType || '',
                location: maintenance.location || '',
                issueDescription: maintenance.issueDescription || '',
                assignedTo: maintenance.assignedTo || '',
                status: maintenance.status || 'Pending',
                totalCost: maintenance.totalCost || '',
                paymentMethod: maintenance.paymentMethod || '',
                paymentDate: maintenance.paymentDate?.split('T')[0] || '',
                paidBy: maintenance.paidBy || '',
                workStartDate: maintenance.workStartDate?.split('T')[0] || '',
                workCompletionDate: maintenance.workCompletionDate?.split('T')[0] || '',
            });
        }
    }, [maintenance]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await dispatch(updateMaintenance({ id: id, maintenanceData: formData })).unwrap();

            if (response) {
                toast.success('Maintenance has been updated!');
                navigate('/maintenances');
            } else {
                toast.error('An error occurred while updating the maintenance.');
            }
        } catch (error) {
            toast.error('Update failed!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div class="container mt-1 text-white">
                <h2 class="mb-4 text-center">Update Maintenance Form</h2>
                <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="form-label">Title</label>
                            <input type="text" name="title" className="form-control" value={formData.title} onChange={handleChange} required />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Maintenance Type</label>
                            <select name="maintenanceType" className="form-select" value={formData.maintenanceType} onChange={handleChange} required>
                                <option value="" disabled>Select type</option>
                                <option value="Plumbing">Plumbing</option>
                                <option value="Electrical">Electrical</option>
                                <option value="Cleaning">Cleaning</option>
                                <option value="Furniture">Furniture</option>
                                <option value="Gardening">Gardening</option>
                                <option value="Painting">Painting</option>
                                <option value="Geyser">Geyser</option>
                                <option value="Fridge">Fridge</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Room/Area Number</label>
                            <input type="text" name="location" className="form-control" value={formData.location} onChange={handleChange} required />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="form-label">Issue Description</label>
                            <textarea name="issueDescription" className="form-control" value={formData.issueDescription} onChange={handleChange} rows="2" required />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Assigned To</label>
                            <input type="text" name="assignedTo" className="form-control" value={formData.assignedTo} onChange={handleChange} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Status</label>
                            <select name="status" className="form-select" value={formData.status} onChange={handleChange}>
                                <option value="Pending">Pending</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Completed">Completed</option>
                                <option value="Cancelled">Cancelled</option>
                            </select>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="form-label">Total Cost</label>
                            <input type="number" name="totalCost" className="form-control" value={formData.totalCost} onChange={handleChange} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Payment Method</label>
                            <select name="paymentMethod" className="form-select" value={formData.paymentMethod} onChange={handleChange}>
                                <option value="" disabled>Select payment method</option>
                                <option value="Cash">Cash</option>
                                <option value="Bank Transfer">Bank Transfer</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Payment Date</label>
                            <input type="date" name="paymentDate" className="form-control" value={formData.paymentDate} onChange={handleChange} />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="form-label">Paid By</label>
                            <input type="text" name="paidBy" className="form-control" value={formData.paidBy} onChange={handleChange} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Work Start Date</label>
                            <input type="date" name="workStartDate" className="form-control" value={formData.workStartDate} onChange={handleChange} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Work Completion Date</label>
                            <input type="date" name="workCompletionDate" className="form-control" value={formData.workCompletionDate} onChange={handleChange} />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        <button type="submit" className="btn btn-primary text-white" disabled={loading}>
                            {loading ? (
                                <span><span className="spinner-border spinner-border-sm me-2"></span>Updating...</span>
                            ) : (
                                'Update'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default UpdateMaintenance
